import React from 'react';
import { toDollarAmountOrDash } from '../FONASUCustomerInformation/util';
import {
  MFBeaconButton,
  MFBeaconIconButton,
  MFBeaconModal
} from '../Beacon/BeaconComponents';
import styles from './style.css';
import { modalCloseHandler } from '../Modal/utils';
import closeBtn from '../../assets/images/Icon-button-close-beacon.svg';
import { redirectToAccountFinder } from '../../flows/shared/utils';

const MaxedOutContributionsModal = ({ appState }) => {
  const {
    store: {
      app: {
        customer: {
          name: { firstName }
        }
      },
      loadedData: {
        contributionLimits: { currentYearMaximumLimit }
      }
    }
  } = appState;

  const modalTitle = `Well done, ${firstName}`;

  const handleButtonClick = () => {
    modalCloseHandler();
    redirectToAccountFinder();
  };

  return (
    <MFBeaconModal open removeCloseButton>
      <span className="modal-close-icon">
        <MFBeaconIconButton
          id="maxedOutModalCloseIcon"
          role="button"
          variant="tertiary"
          onClick={handleButtonClick}
          label="close-button">
          <img slot="icon" src={closeBtn} alt="close icon" />
        </MFBeaconIconButton>
      </span>
      <div className="beacon-modal__title">{modalTitle}</div>
      <div className="beacon-modal__description">
        <p>
          You have maxed out this year&apos;s IRA contribution limit of{' '}
          {toDollarAmountOrDash(currentYearMaximumLimit)}
        </p>
        <p>
          You can open a general investment account or view all account types.
        </p>
        <p>Call for more options:</p>
        <p>
          <a className="link-button" href="tel:1-855-793-6611">
            1-855-793-6611
          </a>
        </p>
      </div>
      <div slot="action-zone" className="contrib-modal-btn-container">
        <MFBeaconButton
          role="button"
          noButtonMargin
          variant="tertiary"
          id="maxedOutContributionsModalViewAccounts"
          data-name="maxedOutContributionsModalViewAccounts"
          type="button"
          onClick={handleButtonClick}
          label="View all accounts"
        />
      </div>
      <style jsx>{styles}</style>
    </MFBeaconModal>
  );
};

export default MaxedOutContributionsModal;
